import {Module} from "../index";
import {Season} from "@/modules/season/entity";
import {VueModule} from "@/modules/vue";
import {DayEvaluator} from "@/modules/season/services/DayEvaluator";
import {EndOfSeasonEventSubscriber} from "@/modules/season/subscribers/EndOfSeasonEventSubscriber";
import Evaluation from "./pages/Evaluation.vue";
import messages from "./resources/messages";
import {routes} from "./resources/routes";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import isToday from "dayjs/plugin/isToday";
import weekOfYear from "dayjs/plugin/weekOfYear";
import weekday from "dayjs/plugin/weekday";
import localizedFormat from "dayjs/plugin/localizedFormat";
import duration from "dayjs/plugin/duration";
import relativeTime from "dayjs/plugin/relativeTime";
import "dayjs/locale/de";
import {GameCreationEventSubscriber} from "@/modules/season/subscribers/GameCreationEventSubscriber";
import {SeasonEvaluationEventSubscriber} from "@/modules/season/subscribers/SeasonEvaluationEventSubscriber";

export class SeasonModule extends Module {
  messages = messages;
  routes = routes;

  eventSubscribers = [
    EndOfSeasonEventSubscriber,
    GameCreationEventSubscriber,
    SeasonEvaluationEventSubscriber,
  ];

  dependsOn = [
    VueModule,
  ];

  public entities = [
    Season,
  ];

  protected register() {
    super.register();

    dayjs.extend(utc);
    dayjs.extend(isToday);
    dayjs.extend(localizedFormat);
    dayjs.extend(weekOfYear);
    dayjs.extend(weekday);
    dayjs.extend(duration);
    dayjs.extend(relativeTime);

    this.app.bind<DayEvaluator>(DayEvaluator).to(DayEvaluator);
  }

  boot() {
    super.boot();
  }
}
